exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tree-demo-file-list {\n  height: 100%;\n  background-color: white;\n  overflow: auto;\n}\n", ""]);

// exports
